import { Box } from "@mui/material";
import { useState } from "react";
import UserMenu from "./UserMenu";
import { ProfileButton } from "@knowfully/ui.common";

export default function ProfileMenu() {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchor(event.currentTarget);
  };

  return (
    <Box>
      <ProfileButton onClick={handleClick} />
      <UserMenu anchor={anchor} handleClose={() => setAnchor(null)} />
    </Box>
  );
}
